module.exports = __webpack_public_path__ + "img/filter.98ec09c6.svg";